{
  "auth-process-pages": {
    "login-process-steps": {
      "step-1": {
        "title": "Tên tài khoản",
        "description": "Email hoặc số điện thoại của bạn"
      },
      "step-2": {
        "title": "Bảo mật",
        "description": "Hãy điền thông tin được yêu cầu"
      }
    },
    "register-process-steps": {
      "step-1": {
        "title": "Thông tin cá nhân",
        "description": "Bạn cần điền vào mẫu thông tin"
      },
      "step-2": {
        "title": "Thông tin đăng nhập",
        "description": "Bạn cần thiết lập dữ liệu đăng nhập của mình"
      },
      "step-3": {
        "title": "Xác minh tài khoản",
        "description": "Bạn sẽ nhận được mã pin xác nhận qua email"
      },
      "step-4": {
        "title": "Tài khoản được tạo",
        "description": "Tài khoản của bạn đã được tạo!"
      }
    },
    "meta": {
      "login": {
        "title": "Đăng nhập",
        "description": "Đăng nhập vào Beauty Booking"
      },
      "register": {
        "title": "Đăng ký",
        "description": "Đăng ký tài khoản mới của bạn"
      }
    }
  }
}
